export const MAP_PITCH = 60
export const MAP_BEARING = 40
export const MAP_ZOOM = 14
export const MAP_MAX_PITCH = 60
export const MAP_CENTER = [106.877342, 47.915354]
export const MAP_MOVE_INTERVAL = 1500
export const INTERVAL = 10000
export const MAP_BASE_LAYER_URL = 'http://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png'